import { CommonModule } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzTableModule } from "ng-zorro-antd/table";
import * as uuid from 'uuid';
import { INZorroOutput } from "../../../../core/models/common";
import { CustomTableColumn } from "../../../../core/models/custom-table-fields";
import { CommonService } from "../../../../core/services/common.service";
import { MaterialModule } from "../../../../core/shared/material.module";
import { DropdownWithSectionsComponent } from "../../dropdown-with-sections/dropdown-with-sections.component";

export interface Data {
  id: number;
  name: string;
  age: number;
  address: string;
  disabled: boolean;
}

@Component({
  selector: 'app-zorro-table-tetcase-generator',
  standalone: true,
  imports: [
    NzButtonModule,
    NzTableModule,
    NzCheckboxModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    DropdownWithSectionsComponent
  ],
  templateUrl: './zorro-table-tetcase-generator.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './zorro-table-tetcase-generator.component.scss'
})
export class ZorroTableTetcaseGeneratorComponent {
  @Input() columns: CustomTableColumn[] = [];
  @Input() data: any = [];
  @Input() options: any = {};
  @Input() isEdit: boolean = false;
  @Output() handleActions = new EventEmitter<INZorroOutput>();
  @Output() onRowSelect = new EventEmitter<any>();

 // editing coloumn in the test cases table
  editingCell: { rowId: number; columnKey: string } | null = null;

  isAllChecked = false;
  pageIndex: any = 1;
  isIndeterminate = false;
  selectedRows: any[] = [];
  defaultOptions: any = {
    pageSize: 10,
    showPagination: true,
    showPageSizeChanger: true,
  };
  mapOfExpandedData: { [key: string]: any[] } = {};
  displayData:any

  constructor(
        private commonService: CommonService,
        private changeDetectorRef: ChangeDetectorRef
  ) {}
   

  ngOnInit() {
    this.options = { ...this.defaultOptions, ...this.options };
    this.initializeTable();

    this.commonService.testCaseDeleted$.subscribe((deletedTestCases: any) => {
      this.displayData = this.displayData.filter(
        (item:any) => !deletedTestCases.map((d:any) => d._id).includes(item._id)
      );
    });

    // Set all thumbs-up active
  this.data.forEach((row: any) => {
    row.feedbackEnabled = false;
    row.iconClicked = 0;
  });

  const event = { target: { checked: true } };
  this.onSelectAll(event);
  }

  initializeTable() {
    this.data = Array.isArray(this.data) ? this.data : [];
    this.data = this.data.map((record: any) => ({
      ...record,
      feedbackEnabled: false, // Ensure thumbs-up is active
      iconClicked: 0
    }));
  
    if (this.options.showPagination) {
      this.displayData = [...this.data.slice(0, this.options.pageSize)];
    } else {
      this.displayData = [...this.data];
    }
    this.reOrderExpandableRows();
    const event = { target: { checked: true } };
    this.onSelectAll(event);
  }
  
  
  reOrderExpandableRows() {
    this.data.forEach((item: any) => {
      if(!item.id) {
        item.id = uuid.v4();
      }
      this.mapOfExpandedData[item.id] = this.convertTreeToList(item);
    });
  }

  refreshTableData() {
    this.initializeTable();
  }

  convertTreeToList(root: any): any[] {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: this.isAlreadyExpanded(root.id) });

    while (stack.length !== 0) {
      const node = stack.pop()!;
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level! + 1, expand: this.isAlreadyExpanded(root.id, node.children[i].id), parent: node});
        }
      }
      this.visitNode(node, hashMap, array);
    }
    return array;
  }

  visitNode(node: any, hashMap: { [key: string]: boolean }, array: any[]): void {
    if (!hashMap[node.id]) {
      hashMap[node.id] = true;
      array.push(node);
    }
  }

  isAlreadyExpanded(id: string, childId?: string) {
    let isFound;
    if(childId) {
      isFound = this.mapOfExpandedData[id]?.find((ele: any) => ele.id === childId);
    } else {
      isFound = this.mapOfExpandedData[id]?.find((ele: any) => ele.id === id);
    }
    return isFound?.expand ? true : false;
  }

  collapse(array: any[], data: any, $event: boolean): void {
    data.expand = $event;
    if (data.children && !$event) {
      data.children.forEach((d: any) => {
        const target = array.find(a => a.id === d.id)!;
        target.expand = $event;
        this.collapse(array, target, $event);
      });
    }
  }

  selectAllRows() {
    this.isAllChecked = true;
    // this.isIndeterminate = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["data"]) {
      this.refreshTableData();
    }
  }

  onSelectAll(event: any): void {
    this.isAllChecked = event.target.checked;
    this.isIndeterminate = false;
  
    // If unchecked, clear the data (or set select to false)
    if (!event.target.checked) {
      this.data.forEach((record: any) => {
        record.select = false;
      });
       // Emit updated data
    this.onRowSelect.emit({
      type: 'rowSelect',
      data: [],
    });
    } else {
      // Otherwise, select all
      this.data.forEach((record: any) => {
        record.select = true;
      });
       // Emit updated data
    this.onRowSelect.emit({
      type: 'rowSelect',
      data: this.data,
    });
    }
    // Trigger change detection if necessary
    // this.changeDetectorRef.markForCheck();
  
    this.reOrderExpandableRows();

  }
  
  
 
  onRowSelectChange(): void {
    const allSelected = this.data.every((record: any) => record.select);
    const anySelected = this.data.some((record: any) => record.select);
    this.isAllChecked = allSelected;
    this.isIndeterminate = !allSelected && anySelected;

    // Emit selected and edited data
    this.emitSelectedAndEditedData();
}


  onPageSizeChange(newPageSize: number): void {
    this.options.pageSize = newPageSize;
    this.updateDisplayData();
  }

  onPageIndexChange(newPageIndex: number): void {
    this.pageIndex = newPageIndex;
    this.updateDisplayData();
  }

  updateDisplayData(): void {
    const startIndex = (this.pageIndex - 1) * this.options.pageSize;
    const endIndex = startIndex + this.options.pageSize;
    this.displayData = [...this.data.slice(startIndex, endIndex)];
  }

  getNestedData(row: any, key: string) {
    if (!key) return "";
    let res = key.split(".").reduce((acc, part) => acc && acc[part], row) || "";
    if (!res) {
    }
    return res;
  }

  getString(data: any) {
    return JSON.stringify(data);
  }

  emitAction(type: string, data: any, event?: any, actionType?: string, value?: any) {
    if (type === "textarea") {
      const updatedValue = (event.target as HTMLTextAreaElement).value;
      const updatedRow = { ...data.row };
      updatedRow[data.column.key] = updatedValue;
      data.row = updatedRow;
    }
    if (type === "thumb-feedback") {
      if (event == 1) {
        // Ensure feedbackEnabled is added or set to true
        if (!Object.prototype.hasOwnProperty.call(data.row, "feedbackEnabled")) {
          data.row = Object.assign({}, data.row, { feedbackEnabled: true });
          data.row = Object.assign({}, data.row, { iconClicked: 1 });
        } else {
          data.row.feedbackEnabled = true;
          data.row.iconClicked = 1;
        }
        //on thumbs down show text area

        const updatedValue = (event.target as HTMLTextAreaElement)?.value;
        const updatedRow = { ...data.row };
        updatedRow[data.column.key] = updatedValue;
        data.row = updatedRow;
      } else if(event == 0) {
        if (!Object.prototype.hasOwnProperty.call(data.row, 'feedbackEnabled')) {
          data.row = Object.assign({}, data.row, { feedbackEnabled: false });
          data.row = Object.assign({}, data.row, { iconClicked: 0 });
        } else {
          data.row.feedbackEnabled = false;
          data.row.iconClicked = 0;
        }
      }
    }

    this.handleActions.emit({
      type,
      data,
      actionType,
      value
    });
  }

  getGroupClassName(list: any, classList?: any) {
    return classList ? classList : `col-md-${12 / list.length}`;
  }

  expandSet = new Set<number>();
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }



  enableEdit(row: any, columnKey: string) {
    const editableColumns = ['prerequisites', 'testScenario', 'expectedResult'];
    if (editableColumns.includes(columnKey) && this.isEdit) {
      this.editingCell = { rowId: row.testCaseId, columnKey };
    }
  }
  
 
  saveEdit(row: any, columnKey: string, event: any) {
    const newValue = event?.target?.value.trim();
    // Find the index of the row in displayData
    const rowIndex = this.displayData.findIndex((record: any) => record?.testCaseId === row?.testCaseId);
    const rowIndexAllData = this.data.findIndex((record: any) => record?.testCaseId === row?.testCaseId);
    if (rowIndex !== -1) {
        // Preserve the selection state while updating the row
        this.displayData[rowIndex] = { ...this.displayData[rowIndex], [columnKey]: newValue };
  
    }
    if (rowIndexAllData !== -1) {
      this.data[rowIndex] = { ...this.data[rowIndex], [columnKey]: newValue };
    }
    // Optionally, clear the editing cell state
    this.editingCell = null;
    // Emit the updated selected and edited data
    this.emitSelectedAndEditedData();
}

emitSelectedAndEditedData(): void {
  const selectedAndEditedData = this.data.filter((record: any) => record.select);
  // const selectedAndEditedData = this.displayData.filter((record: any) => record.select);
  
  this.onRowSelect.emit({
      type: "rowSelect",
      data: selectedAndEditedData,
  });
}

}
